import React from 'react';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import Input from '../../../../../components/input/Input';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CountOfTotal from '../../../../../components/CountOfTotal';
import Select from '../../../../../components/input/Select';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL } from '../../../../../store/modules/remoteImage/models';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO,
  REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/remoteImageConstants';
import { addAllItemToSelectList } from '../../../../../lib/common';
import './RemoteImageReferralSearchBox.scss';

const RemoteImageReferralSearchBox = (props) => {
  const { searchData, setData, getList } = props;
  const { exposeLocationType, memo, createDate } = searchData;

  return (
    <SearchBox
      className="remote-image-search-box"
      onSearch={() =>
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        })
      }
      onClear={() => {
        getList({
          searchOption: [],
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL,
        });
      }}
    >
      <BaseForm
        label="노출위치 타입"
        content={
          <Select
            className="img-type"
            list={addAllItemToSelectList(REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_SELECT_LIST)}
            onChange={(type) =>
              setData({
                path: ['exposeLocationType'],
                value: type,
              })
            }
            value={exposeLocationType}
            isTable={true}
            size="large"
          />
        }
      />

      <BaseForm
        label={
          <span>
            <span>메모</span>
            <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO} />
          </span>
        }
        content={
          <Input
            className="memo"
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO}
            size="large"
          />
        }
      />

      <BaseForm
        label="레퍼럴 이미지 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default RemoteImageReferralSearchBox;
